<template>
    <select v-model="internalValue">
        <option value="0">{{ $t('gender.female') }}</option>
        <option value="1">{{ $t('gender.male') }}</option>
        <option value="0.5">{{ $t('gender.unknown') }}</option>
    </select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: number) => typeof payload === "number",
    },

    setup(props, {emit})
    {
        const internalValue = ref(props.modelValue.toString());

        watch(internalValue, (newValue) => {
            emit("update:modelValue", Number.parseFloat(newValue));
        });

        return { internalValue };
    },
})
</script>
